import Common from "../../../../Common";

interface Body {
	id: id
	ivrId: id
	selection: string
	pbx_destination_id: id
	description?: string
}

const Item = class extends Common {
	read = (companyId: id, ivrId: id, id: id) =>
		this.get(`/company/${companyId}/pbx/ivr/${ivrId}/item/${id}`);

	create = (companyId: id, ivrId: id, data: Body, options?: DadExtraOptions) =>
		this.post(`/company/${companyId}/pbx/ivr/${ivrId}/item${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data);

	update = (companyId: id, ivrId: id, id: id, data: Body, options?: DadExtraOptions) =>
		this.patch(`/company/${companyId}/pbx/ivr/${ivrId}/item/${id}${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data);

	delete = (companyId: id, ivrId: id, id: id) =>
		this.doDelete(`/company/${companyId}/pbx/ivr/${ivrId}/item/${id}`);
}

export default Item
